module.exports = __webpack_public_path__ + "static/sport/login-2.580eccb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/september10/form/login-2.png
// module id = bcrt
// module chunks = 0